// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"678":"01f30c46311fdc87","888":"bf648e909ed8d489"}[chunkId] + ".css";
};